import MultiOrderGraphics from "@coworker/app/src/assets/svg/multiorder-graphics.svg?react";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaList } from "@coworker/apprestructured/src/shared/wrappers/FixaList/FixaList";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CheckmarkGreenSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CheckmarkGreenSmallPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import ModalColumn from "@coworker/apprestructured/src/task-management/components/ModalColumn/ModalColumn";
import { useTranslation } from "@coworker/locales";
import { getRefillAreaIdFromLocation } from "@fixa/store-locations";
import { useCallback } from "react";
import { useSearchParams } from "react-router";
import styles from "./CreateMoreAddonOrdersModal.module.css";

export const CreateMoreAddonOrdersModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const multiOrder = searchParams.get("multiOrder") === "true";
  const location = searchParams.get("location") ?? "";

  const hfb = getRefillAreaIdFromLocation(location);

  const { t } = useTranslation();

  const navigate = useFixaNavigate();

  const handleCloseClick = useCallback(() => {
    trackerHelper.multiOrderAddonsModal.trackCloseClick();
    setSearchParams((prev) => {
      prev.delete("multiOrder");
      prev.delete("location");
      return prev;
    });
  }, [setSearchParams]);

  const handleContinueClick = useCallback(() => {
    trackerHelper.multiOrderAddonsModal.trackContinueClick();
    if (hfb) {
      navigate(`/multi-order-addons/refill-area/${hfb}`);
    } else {
      navigate("/multi-order-addons");
    }
  }, [navigate, hfb]);

  if (!multiOrder) {
    return null;
  }

  return (
    <FixaModal handleCloseBtn={handleCloseClick} visible={multiOrder}>
      <FixaSheets
        ariaLabel={t("continueToMultiOrderAddonsString")}
        header={<FixaModalHeader closeBtnClick={handleCloseClick} />}
        footer={
          <FixaModalFooter
            children={
              <FixaButton
                type="primary"
                text={t("continueToMultiOrderAddonsString")}
                fluid
                onClick={handleContinueClick}
              />
            }
            renderBorder
          />
        }
      >
        <FixaModalBody>
          <div className={styles["header"]}>
            <ModalColumn gap="small">
              <FixaText textStyle="Heading.L">
                {t("createMoreAddonOrdersInAreaString")}
              </FixaText>
              <FixaText textStyle="Body.L">
                {t("useMultiOrderAddonsDescriptionString")}
              </FixaText>
            </ModalColumn>
          </div>
          <div className={styles["content"]}>
            <MultiOrderGraphics width={112} height={171} />
            <div>
              <FixaList size="small">
                <li>
                  <FixaText
                    textStyle="Label.S"
                    className={styles["listItemText"]}
                  >
                    {t("selectMultipleArticlesAndLocationsString")}
                  </FixaText>
                </li>
                <li>
                  <FixaText
                    textStyle="Label.S"
                    className={styles["listItemText"]}
                  >
                    {t("enterRefillQuantityString")}
                  </FixaText>
                </li>
                <li>
                  <FixaText
                    textStyle="Label.S"
                    className={styles["listItemText"]}
                  >
                    {t("chooseAssigneeString")}
                  </FixaText>
                </li>
              </FixaList>
              <div className={styles["done"]}>
                <FixaSSRIcon paths={CheckmarkGreenSmallIconPath} />
                <FixaText textStyle="Label.M">
                  {t("doneExclamationString")}
                </FixaText>
              </div>
            </div>
          </div>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
};
